/**
 * Resolve the visible step counter for a given onboarding step.
 *
 * The flow has two modes:
 *  - First-time onboarding (2 total steps: owner + business, then
 *    location). Venue Vibe (categories/tags) and Operating Hours were
 *    moved to the post-agreement Setup Mode checklist as required
 *    items — the owner completes those from inside the real venue app,
 *    with a live card preview, instead of during the quick wizard.
 *  - "Add another venue" mode (still 2 steps — the owner's name is
 *    pre-filled from their previous venue so Step 1 stays but starts
 *    partially completed).
 */
export function resolveStepCounter(stepInRoute) {
  return { step: stepInRoute, total: 2 };
}
